import { CSSProperties } from 'react'

export enum ThemePreset {
  Light = 'light',
  Dark = 'dark',
  Saturated = 'saturated',
}

type ThemeVariables =
  | 'sidebarBackgroundColor'
  | 'actionColor'
  | 'sidebarIconsColor'
  | 'sidebarTextColor'
  | 'sidebarSelectedBackgroundColor'
  | 'sidebarSelectedTextColor'
  | 'sidebarHoverBackgroundColor'
  | 'sidebarHoverTextColor'

export type Hue = number
export type Lightness = number
export type Saturation = number
export type Alpha = number
type Hex = string

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export type Overrides = { [key in ThemeVariables]: Hex }

export type HSLSpec = [Hue | [Hue, Hue], Saturation, Lightness, Alpha]

export interface ITheme {
  hue?: Hue | null
  preset?: ThemePreset | null
  overrides?: Overrides | null
}

export interface ThemeCSSProperties extends CSSProperties {
  '--action-50'?: string
  '--action-60'?: string
  '--neutral-0'?: string
  '--neutral-5'?: string
  '--neutral-10'?: string
  '--neutral-30'?: string
  '--neutral-50'?: string
  '--neutral-90'?: string
  '--focus-50'?: string
  '--glass-sidebar-background-color'?: string
  '--sidebar-background-color'?: string
  '--nav-item-icon-color'?: string
  '--nav-item-color'?: string
  '--nav-item-control-color'?: string
  '--nav-item-section-header-color'?: string
  '--nav-item-control-icon-color'?: string
  '--nav-item-icon-color-hover'?: string
  '--nav-item-color-hover'?: string
  '--nav-item-background-color-hover'?: string
  '--nav-item-control-color-hover'?: string
  '--nav-item-icon-color-active'?: string
  '--nav-item-color-active'?: string
  '--nav-item-background-color-active'?: string
  '--nav-item-control-color-active'?: string
  '--notifications-active-icon-color'?: string
  '--override-menu-item-color'?: string
  '--override-menu-item-background-color-hover'?: string
  '--override-menu-item-color-active'?: string
  '--override-menu-item-background-color-active'?: string
  '--override-menu-item-background-color-active-hover'?: string
  '--override-menu-item-background-color-focus'?: string
  '--override-menu-item-icon-color'?: string
  '--override-menu-item-checkbox-color'?: string
  '--override-menu-item-chevron-color'?: string
  '--override-menu-section-header-color'?: string
}
